import { Component, Mixins } from "vue-property-decorator";
import { DynPanelAware } from '@/components/dyn-panel';
import RightsAware from '@/lib/mixins/rights-aware';
import CavCavite from '@/lib/models/cav-cavite';
import { State, Getter } from 'vuex-class';
import CavCus from '@/lib/models/cav-cus';
import { FLEX_PROFILES } from '@/lib/models/user';

@Component
export default class PartEmsMain extends Mixins(DynPanelAware, RightsAware) {

  @Getter getPositionableBeanCoord;
  @Getter userhHasHigherFlexProfileThan;

  @State(s => s.caviteEdit.editedCavite) data: CavCavite;

  created() {
    this.readonly_ = !this.userhHasHigherFlexProfileThan(FLEX_PROFILES.CUS_LECTEUR);
  }

  mounted() {
    if (!this.data.cus) {
      this.data.cus = new CavCus();
    }
  }

  render() {
    if (!this.data || !this.data.cus) return null;
    return (
      <div class="main-tab-inner sub-tabs">
        <div class="tabs is-small">
          <ul>
            <router-link tag="li" to={{name: 'cavite.edit.ems.identification'}}><a>Identification et accès</a></router-link>
            <router-link tag="li" to={{name: 'cavite.edit.ems.descriptionOuvrage'}}><a>Description de l'ouvrage</a></router-link>
            <router-link tag="li" to={{name: 'cavite.edit.ems.docPlans'}}><a>Documents et plans</a></router-link>
            <router-link tag="li" to={{name: 'cavite.edit.ems.desordreSecu'}}><a>Désordre/Sécurité</a></router-link>
            <router-link tag="li" to={{name: 'cavite.edit.ems.actions'}}><a>Actions</a></router-link>
            <router-link tag="li" to={{name: 'cavite.edit.ems.suiviTravaux'}}><a>Suivi/Travaux</a></router-link>
            <router-link tag="li" to={{
              name: 'cavite.edit.ems.carto',
              params: {
                commune: this.data.commune,
                cavCoords: this.getPositionableBeanCoord(this.data)
              }
            }}><a>Cartographie</a>
            </router-link>
          </ul>
        </div>
        <div class="block-main-content">
          <router-view name="mainEmsTab"/> 
        </div>
      </div>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-38a4670c/main.tsx" });